import Smartphones from 'Employees/views/EmployeeView/containers/Smartphones'
import Tablets from 'Employees/views/EmployeeView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const EmployeeView = getCurrentDeviceView(Smartphones, Tablets)

export default EmployeeView
